import { supabaseClient } from "@/lib/database/supabase";
import { RealtimeChannel, RealtimePostgresDeletePayload, RealtimePostgresInsertPayload, RealtimePostgresUpdatePayload } from "@supabase/supabase-js";
import { onBeforeMount, onBeforeUnmount, ref, useId } from "vue";

export default function<T extends {[key: string]: any }>(table: string, {
  handleInsert,
  handleUpdate,
  handleUpsert,
  handleDelete,
}: {
  handleInsert?: (payload: RealtimePostgresInsertPayload<T>) => void,
  handleUpdate?: (payload: RealtimePostgresUpdatePayload<T>) => void,
  handleUpsert?: (payload: RealtimePostgresInsertPayload<T> | RealtimePostgresUpdatePayload<T>) => void,
  handleDelete?: (payload: RealtimePostgresDeletePayload<T>) => void,
}) {
  const channel = ref<RealtimeChannel | null>(null);
  const channelName = `realtime:${table}:${useId()}`;

  onBeforeMount(() => {
    channel.value = supabaseClient.channel(channelName);

    if (handleInsert || handleUpsert) {
      channel.value.on("postgres_changes", {
        event: "INSERT",
        schema: "public",
        table,
      }, handleInsert || handleUpsert as (payload: RealtimePostgresInsertPayload<T>) => void);
    }

    if (handleUpdate || handleUpsert) {
      channel.value.on("postgres_changes", {
        event: "UPDATE",
        schema: "public",
        table,
      }, handleUpdate || handleUpsert as (payload: RealtimePostgresUpdatePayload<T>) => void);
    }

    if (handleDelete) {
      channel.value.on("postgres_changes", {
        event: "DELETE",
        schema: "public",
        table,
      }, handleDelete);
    }

    channel.value.subscribe();
  });

  onBeforeUnmount(() => {
    channel.value?.unsubscribe();
    channel.value = null;
  });

  return {
    channel,
  };
}
